import React from 'react';
import { motion } from 'framer-motion';
const fadeUp = {
  hidden: {
    opacity: 0,
    y: 30
  },
  show: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6
    }
  }
};
export function EmotionalClose() {
  return <motion.div variants={fadeUp} initial="hidden" whileInView="show" viewport={{
    once: true
  }} className="text-center max-w-2xl mx-auto" data-id="element-54">
      <h2 className="text-3xl max-sm:text-2xl font-serif font-bold text-[#E8E0D0] mb-8 max-sm:mb-5" data-id="element-55">
        Hay dos tipos de personas que llegan hasta aquí.
      </h2>
      <div className="space-y-6 max-sm:space-y-4 text-lg max-sm:text-base text-[#A09880] mb-10 max-sm:mb-6" data-id="element-56">
        <p data-id="element-57">
          Las que dicen:{' '}
          <span className="italic" data-id="element-58">"Suena bien, lo pienso y vuelvo."</span>
        </p>
        <p data-id="element-59">
          Y las que dicen:{' '}
          <span className="text-[#E8E0D0] font-bold" data-id="element-60">
            "Ya perdí suficiente tiempo. Esto empieza hoy."
          </span>
        </p>
        <div className="h-px w-24 bg-[#D4AF37]/30 mx-auto my-8" data-id="element-61"></div>
        <p data-id="element-62">Las primeras siguen haciendo lo mismo mañana.</p>
        <p className="text-[#D4AF37] font-serif font-bold text-xl italic" data-id="element-63">
          Las segundas tienen su semana organizada antes del lunes. 🚀
        </p>
      </div>
      <p className="text-2xl font-black text-[#E8E0D0] uppercase tracking-wide" data-id="element-64">
        Tú ya sabes qué tipo de persona eres.
      </p>
    </motion.div>;
}